import type { TFn } from '@/lib/i18n';

export const ACTION_LABEL_KEYS: Record<string, string> = {
  create: 'auditLogs.actionCreate',
  update: 'auditLogs.actionUpdate',
  softDelete: 'auditLogs.actionSoftDelete',
  destroy: 'auditLogs.actionDestroy',
  bulkSoftDelete: 'auditLogs.actionBulkSoftDelete',
  bulkDestroy: 'auditLogs.actionBulkDestroy',
  bulkWrite: 'auditLogs.actionBulkWrite'
};

export const ACTION_VARIANTS: Record<string, 'default' | 'secondary' | 'destructive' | 'outline'> =
  {
    create: 'default',
    update: 'secondary',
    softDelete: 'destructive',
    destroy: 'destructive',
    bulkSoftDelete: 'destructive',
    bulkDestroy: 'destructive',
    bulkWrite: 'outline'
  };

// Entity types registered in ConnectionManager.TENANT_SCHEMAS
export const TENANT_ENTITY_TYPES = [
  'User',
  'Department',
  'OrgFunction',
  'Process',
  'ProcessStepRecording',
  'ProcessStepAssignment',
  'Survey',
  'Artifact',
  'ExternalContact',
  'SoftwareSystem',
  'Organization',
  'BliksyGeneration',
  'ProcessConnection',
  'ProcessChain',
  'ProcessMapPosition',
  'ProcessMapLaneDimension'
];

// Entity types registered only at the superadmin level (no tenant selected)
export const SUPERADMIN_ENTITY_TYPES = ['Tenant', 'AppRegistry', 'PlatformSettings'];

export const DEFAULT_PAGE_SIZE = 25;

export function getActionLabel(t: TFn, action: string): string {
  const key = ACTION_LABEL_KEYS[action];
  return key ? t(key) : action;
}

export function getEntityTypeLabel(t: TFn, entityType: string): string {
  return t(`common.entityTypes.${entityType}`, { defaultValue: entityType });
}

export function parseDateRange(raw: string | undefined): { from?: string; to?: string } {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as { from?: string; to?: string };
    return {
      from: parsed.from || undefined,
      to: parsed.to || undefined
    };
  } catch {
    return {};
  }
}
